import { ENDPOINTS } from "@/constants/apiConstants";
import { apiSlice } from "../baseApi";

// /dashboard/daily-orderssss

//provideTags works for queries (get)
//invalidatesTags works for mutations (post, put, delete)

// These tags are just identifiers for different types of data
// When a mutation invalidates a tag, all queries that provide that tag will be re-fetched
const authBaseEndpoint = ENDPOINTS.DASHBOARD;

// Daily Orders API
export const dashboardApi = apiSlice
  .enhanceEndpoints({
    addTagTypes: ["dailyOrders"],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDailyOrders: builder.query({
        query: () => `${authBaseEndpoint}daily-orders`,
        transformResponse: (response) => response.data,
        // providesTags: () => [{ type: "dailyOrders" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      //for metric stats
      getTotalStats: builder.query({
        query: () => `${authBaseEndpoint}stats`,
        transformResponse: (response) => response.data,
        // providesTags: () => [{ type: "dailyOrders" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      getMonthlyStats: builder.query({
        query: () => `${authBaseEndpoint}monthly-stats`,
        transformResponse: (response) => {
          return response?.data || response;
        },
        // providesTags: () => [{ type: "dailyOrders" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      //for the line chart
      getDailyStats: builder.query({
        query: () => `${authBaseEndpoint}daily-purchase-stats`,
        transformResponse: (response) => {
          // console.log("Raw Response in transformResponse:", response);
          return response?.data || response; // Fallback to response if no data property
        },
        // providesTags: () => [{ type: "dailyOrders" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      getPurchaseStat: builder.query({
        query: () => `${authBaseEndpoint}purchase-stats`,
        transformResponse: (response) => {
          // console.log("Raw Response in transformResponse:", response);
          return response?.data || response;
        },
        // providesTags: () => [{ type: "dailyOrders" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      getTopCategories: builder.query({
        query: () => `${authBaseEndpoint}top-categories`,
        transformResponse: (response) => response.data,
        // providesTags: () => [{ type: "dailyOrders" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      getTopProduct: builder.query({
        query: () => `${authBaseEndpoint}top-products`,
        transformResponse: (response) => {
          return response?.data || response;
        },
        // providesTags: () => [{ type: "dailyOrders" }],
        keepUnusedDataFor: 0, // Set to 0 seconds to always fetch fresh data
      }),
      //   addDailyOrders: builder.mutation({
      //     query: (requestData) => ({
      //       url: "/Company/requestDemo",
      //       method: "POST",
      //       body: requestData,
      //     }),
      //     invalidatesTags: () => [{ type: "dailyOrders" }],
      //   }),
    }),
  });

// Export hooks for usage in components

export const {
  useGetDailyOrdersQuery,
  useGetDailyStatsQuery,
  useGetMonthlyStatsQuery,
  useGetPurchaseStatQuery,
  useGetTopCategoriesQuery,
  useGetTopProductQuery,
  useGetTotalStatsQuery,
} = dashboardApi;
